<script lang="ts">
	interface Props {
		name: 'alert' | 'info' | 'clock' | 'warning' | 'success' | 'close' | 'plus' | 'arrow-up' | 'arrow-down' | 'arrow-right' | 'heart' | 'file-plus' | 'user-plus';
		class?: string;
	}

	let { name, class: cls = '' }: Props = $props();
</script>

{#if name === 'alert'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<circle cx="12" cy="12" r="10"/>
		<line x1="12" y1="8" x2="12" y2="12"/>
		<line x1="12" y1="16" x2="12.01" y2="16"/>
	</svg>
{:else if name === 'info'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<circle cx="12" cy="12" r="10"/>
		<line x1="12" y1="16" x2="12" y2="12"/>
		<line x1="12" y1="8" x2="12.01" y2="8"/>
	</svg>
{:else if name === 'clock'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<circle cx="12" cy="12" r="10"/>
		<polyline points="12 6 12 12 16 14"/>
	</svg>
{:else if name === 'warning'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
		<line x1="12" y1="9" x2="12" y2="13"/>
		<line x1="12" y1="17" x2="12.01" y2="17"/>
	</svg>
{:else if name === 'success'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<polyline points="20 6 9 17 4 12"/>
	</svg>
{:else if name === 'close'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<line x1="18" y1="6" x2="6" y2="18"/>
		<line x1="6" y1="6" x2="18" y2="18"/>
	</svg>
{:else if name === 'plus'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<line x1="12" y1="5" x2="12" y2="19"/>
		<line x1="5" y1="12" x2="19" y2="12"/>
	</svg>
{:else if name === 'arrow-up'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<line x1="12" y1="19" x2="12" y2="5"/>
		<polyline points="5 12 12 5 19 12"/>
	</svg>
{:else if name === 'arrow-down'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<line x1="12" y1="5" x2="12" y2="19"/>
		<polyline points="19 12 12 19 5 12"/>
	</svg>
{:else if name === 'arrow-right'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<line x1="5" y1="12" x2="19" y2="12"/>
		<polyline points="12 5 19 12 12 19"/>
	</svg>
{:else if name === 'heart'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
	</svg>
{:else if name === 'file-plus'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
		<polyline points="14 2 14 8 20 8" />
		<line x1="12" y1="18" x2="12" y2="12" />
		<line x1="9" y1="15" x2="15" y2="15" />
	</svg>
{:else if name === 'user-plus'}
	<svg xmlns="http://www.w3.org/2000/svg" class={cls} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
		<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
		<circle cx="9" cy="7" r="4" />
		<line x1="19" y1="8" x2="19" y2="14" />
		<line x1="22" y1="11" x2="16" y2="11" />
	</svg>
{/if}
